import { Box, TextField, Typography } from '@mui/material';
import type { QuoteDetail } from '../../../types/quote';

interface QuoteScopeSectionProps {
  quote: QuoteDetail;
  onUpdate: (data: Record<string, unknown>) => void;
  readOnly?: boolean;
}

export const QuoteScopeSection = ({ quote, onUpdate, readOnly }: QuoteScopeSectionProps) => {
  const handleBlur = (field: string, value: string) => {
    if ((quote as Record<string, unknown>)[field] !== value) {
      onUpdate({ [field]: value || null });
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 3 }}>
        Scope &amp; Notes
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 800 }}>
        <TextField
          label="Scope of Work"
          multiline
          rows={6}
          defaultValue={quote.ScopeOfWork ?? ''}
          onBlur={(e) => handleBlur('ScopeOfWork', e.target.value)}
          size="small"
          fullWidth
          disabled={readOnly}
        />

        <TextField
          label="Assumptions"
          multiline
          rows={4}
          defaultValue={quote.Assumptions ?? ''}
          onBlur={(e) => handleBlur('Assumptions', e.target.value)}
          size="small"
          fullWidth
          disabled={readOnly}
        />

        <TextField
          label="Intro Message"
          multiline
          rows={4}
          defaultValue={quote.IntroMessage ?? ''}
          onBlur={(e) => handleBlur('IntroMessage', e.target.value)}
          size="small"
          fullWidth
          disabled={readOnly}
        />
      </Box>
    </Box>
  );
};
